import React from 'react';
import { FileCheck, HandCoins, ShieldCheck, PenLine } from 'lucide-react';
import { cn } from '../../lib/utils';
const POINTS = [{
  icon: FileCheck,
  title: 'Clear scope and fee first',
  body: 'You receive the proposed scope and a confirmed fee before any work begins, so you can decide with the cost in front of you.'
}, {
  icon: HandCoins,
  title: 'No obligation to proceed',
  body: 'A quote is just a quote. There is no obligation to continue after we set out the scope and fee for your matter.'
}, {
  icon: ShieldCheck,
  title: 'No surprise costs',
  body: 'Additional costs are not added later without your agreement. If the matter changes, we talk to you first.'
}, {
  icon: PenLine,
  title: 'You approve before we start',
  body: 'Engagement is confirmed separately and in writing. Work begins once you have approved the scope and fee.'
}];
interface FeeTransparencyProps {
  variant?: 'background' | 'cream';
}
export function FeeTransparency({
  variant = 'cream'
}: FeeTransparencyProps) {
  return <section className={cn('px-5 md:px-6 py-10 md:py-14', variant === 'cream' ? 'bg-cream' : 'bg-background')} data-id="element-489" data-mp="2ubf88bm47orn">
      <div className="max-w-7xl mx-auto" data-id="element-490" data-mp="34aejm1y9lyic">
        <div className="max-w-2xl mb-6 md:mb-8" data-id="element-491" data-mp="349cwv07vznks">
          <p className="eyebrow text-brand-blue mb-1" data-id="element-492" data-mp="392ecjafx3r5f">
            no bill shock
          </p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-493" data-mp="3d4j6696d8ns2">
            How our fees work.
          </h2>
          <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-494" data-mp="3i19l2t6fpdbw">
            Fees depend on the property and the transaction, so we set out a
            confirmed fixed scope and fee up front. You know what you are paying
            before anything starts.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-495" data-mp="1sp7ofeuw1h76">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="h-full flex flex-col rounded-2xl bg-surface border border-border p-5" data-id="element-496" data-mp="1plrwespcff2t">
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-accent-soft text-accent mb-4" data-id="element-497" data-mp="1kpky9m36v7vf">
                  <Icon className="w-6 h-6" data-id="element-498" data-mp="1ukv2mgh27rcd" />
                </span>
                <h3 className="font-serif text-xl text-ink" data-id="element-499" data-mp="1unr0k4swqg0t">{point.title}</h3>
                <p className="mt-2 text-sm text-muted-ink leading-relaxed" data-id="element-500" data-mp="28jcl9zs3ydnf">
                  {point.body}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}